/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Media_AutofillInputs */

const cs_draft_media_autofill = /** @type {(inputs: Draft_Media_AutofillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automaticky`)
};

const en_draft_media_autofill = /** @type {(inputs: Draft_Media_AutofillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autofill`)
};

/**
* | output |
* | --- |
* | "Autofill" |
*
* @param {Draft_Media_AutofillInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_media_autofill = /** @type {((inputs?: Draft_Media_AutofillInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Media_AutofillInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_media_autofill(inputs)
	return cs_draft_media_autofill(inputs)
});